import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  UserFollowedLeadersListLoadAction,
  UserFollowedLeadersListLoadMoreAction,
} from '../../domains/leadersManagement/actions.types';

import { AllUserFollowedLeaders, UserFollowedLeadersList } from './types';

export type UserFollowedLeadersListAction = UserFollowedLeadersListLoadAction | UserFollowedLeadersListLoadMoreAction;

const initialState: AllUserFollowedLeaders = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const loadMoreFulfilledUserFollowedLeadersList = (
  state: AllUserFollowedLeaders,
  userFollowedLeadersList: UserFollowedLeadersList
): AllUserFollowedLeaders => {
  const currentUserFollowedLeadersIds = state.fulfilled?.userFollowedLeaders ?? [];

  return {
    ...state,
    fulfilled: {
      ...userFollowedLeadersList,
      userFollowedLeaders: [...currentUserFollowedLeadersIds, ...userFollowedLeadersList.userFollowedLeaders],
    },
  };
};

const reducer: Reducer<AllUserFollowedLeaders, UserFollowedLeadersListAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FOLLOWED_LEADERS.LOAD_PENDING':
      return setPending();
    case 'FOLLOWED_LEADERS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.userFollowedLeadersList);
    case 'FOLLOWED_LEADERS.LOAD_MORE_FULFILLED':
      return loadMoreFulfilledUserFollowedLeadersList(state, action.payload.entities.userFollowedLeadersList);
    case 'FOLLOWED_LEADERS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
